import React from 'react';
import { FooterMenuProps } from './footer-menu.props';
import Link from 'next/link';

export const FooterMenuOrganism = (props: FooterMenuProps) => {
  return (
    <div data-cy="footer-menu">
      <ul>
        {props.footerLinks.map((footerLink, index) => (
          <li key={index} className="flex flex-col flex-1 m-1">
            <Link href={footerLink.href}>
              <a
                className="text-white text-lg lg:text-base font-light footer_menu_link"
                target="_blank"
                title={`${footerLink.label} link`}
              >
                {footerLink.label}
              </a>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
